import { useMemo } from "react";
import { Separator } from "@/shared/ui/Separator";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuSkeleton,
  SidebarRail,
} from "@/shared/ui/Sidebar";
import { Skeleton } from "@/shared/ui/Skeleton";

const NAVIGATION_SKELETON_COUNT = 7;

const SidebarSkeletonComponent = () => {
  const skeletonItems = useMemo(
    () => Array.from({ length: NAVIGATION_SKELETON_COUNT }, (_, i) => i),
    [],
  );

  return (
    <Sidebar collapsible="icon" variant="floating">
      <SidebarHeader>
        <SidebarMenu>
          {/* Logo skeleton */}
          <SidebarMenuItem>
            <div className="flex items-center justify-center p-2">
              <Skeleton className="h-10 w-36 rounded-lg" />
            </div>
          </SidebarMenuItem>
          <Separator className="my-2" />
          {/* Organization info skeleton */}
          <SidebarMenuItem>
            <div className="flex items-center gap-2 p-2">
              <Skeleton className="size-10 rounded-lg" />
              <div className="flex-1 space-y-1.5">
                <Skeleton className="h-4 w-3/4" />
                <Skeleton className="h-3 w-1/2" />
              </div>
            </div>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>

      <SidebarContent>
        <SidebarGroup>
          <Skeleton className="mb-2 ml-2 h-4 w-16" />
          <SidebarMenu>
            {skeletonItems.map((i) => (
              <SidebarMenuSkeleton key={i} showIcon />
            ))}
          </SidebarMenu>
        </SidebarGroup>
      </SidebarContent>

      <SidebarFooter>
        <div className="flex items-center gap-2 p-2">
          <Skeleton className="h-8 w-8 rounded-lg" />
          <div className="flex-1 space-y-1">
            <Skeleton className="h-3.5 w-24" />
            <Skeleton className="h-3 w-32" />
          </div>
        </div>
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
};

export default SidebarSkeletonComponent;
